import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { CircularProgress, Grid, Typography } from "@material-ui/core";
import BDTLogo from "../../../../assets/images/bdt_logo.svg";

export const LoadingModes = {
    Circular: "circular",
    Linear: "linear",
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            height: "100%",
        },
    })
);

interface LoadingProps {
    label?: string;
    useLogo?: boolean;
}

const Loading = ({ label, useLogo }: LoadingProps): JSX.Element => {
    const classes = useStyles();

    return (
        <Grid
            container
            direction="column"
            justify="center"
            alignContent="center"
            alignItems="center"
            className={classes.root}
        >
            {useLogo && (
                <Grid item>
                    <img src={BDTLogo} alt="BDT logo" />
                </Grid>
            )}
            <Grid item>
                <CircularProgress />
            </Grid>
            {label && (
                <Grid item>
                    <Typography variant="h5">{label}</Typography>
                </Grid>
            )}
        </Grid>
    );
};

export default Loading;
